import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Avatar from '@mui/material/Avatar';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { getexpenses } from '../redux/expenses';
import { Camera, CameraResultType } from '@capacitor/camera';

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [loading, setLoading] = React.useState(false);
  const [person, setPerson] = React.useState('');
  const [imageBase64, setImageBase64] = React.useState('');
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const clearForm = () => {
    setPerson('');
    setImageBase64('');
    document.getElementById('descriptionimp').value = '';
  };

  const capture = async () => {
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.Base64, // Changed to Base64 for direct use
      });
      setImageBase64(image.base64String);
      setPerson(`data:image/jpeg;base64,${image.base64String}`); // Set image for preview
    } catch (err) {
      console.error('Error capturing image:', err);
    }
  };

  const retireExpense = async (e) => {
    e.preventDefault();
    setLoading(true);

    const fd = new FormData();
    fd.append('image', imageBase64);
    fd.append('id', props.chosen.id);
    fd.append('status', 'Retired');
    fd.append('description', document.getElementById('descriptionimp').value);

    try {
      const res = await axios.post('https://server.agrotraciserp.com/api/expenses/editexpenses/', fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (res.status === 200) {
        setLoading(false);
        dispatch(getexpenses({ data: res.data }));
        setSnackbarMessage('Expense retired successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to retire expense.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error retiring expense.');
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Retire
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box>
            <form onSubmit={retireExpense}>
              <label htmlFor="fileimage">
                <Box
                  onClick={capture}
                  sx={{
                    backgroundColor: 'white',
                    border: '1px solid grey',
                    width: '100%',
                    minHeight: '150px',
                    marginBottom: '10px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }}
                >
                  {person ? (
                    <Avatar
                      src={person}
                      variant="rounded"
                      sx={{ width: '100%', height: '100%', borderRadius: '8px' }}
                    />
                  ) : (
                    <Box sx={{ padding: '20px' }}>
                      <CameraAltIcon sx={{ fontSize: 40, color: 'grey' }} />
                      <Typography sx={{ color: 'grey', fontSize: 14 }}>Upload Receipt</Typography>
                    </Box>
                  )}
                </Box>
              </label>
              <TextField
                id="descriptionimp"
                required
                label="Description"
                type="text"
                style={{ width: '98%', marginTop: '15px' }}
                autoComplete="current-text"
              />
              <br />
              <br />
              <div style={{ marginTop: 2, textAlign: 'center', width: '100%' }}>
                {loading ? (
                  <Button variant="outlined" disabled>
                    Loading...
                  </Button>
                ) : (
                  <Button type="submit" variant="outlined" size="large">
                    Retire
                  </Button>
                )}
              </div>
              <br />
              <br />
            </form>
          </Box>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}